import React, { Component } from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import "./Home/Floor.css";
import "./Detail/Detail.css";
import history from "./component/history";
import Floor from "./Home/Floor";
import Detail from "./Detail/Detail";

class App extends Component {
  render() {
    return (
      <HashRouter history={history}>
        <Switch>
          <Route path="/" exact component={Floor} />
          <Route path="/:stand&:id/" component={Detail} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js